import { styled } from '@ori-ui/mui';

export const Root = styled('div')({
  width: '100%',
  overflow: 'hidden',
});

export const Inner = styled('div')(({ theme }) => ({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: 'minmax(150px, 1fr)',
  justifyContent: 'center',
  justifyItems: 'center',
  columnGap: theme.spacing(3),
}));
